import { render, staticRenderFns } from "./RevenueHistoryTable.vue?vue&type=template&id=ba9e3d8e"
import script from "./RevenueHistoryTable.vue?vue&type=script&lang=js"
export * from "./RevenueHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports